var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgAlertCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.667 18h2.666v2.666h-2.666V18Zm0-10.667h2.666v8h-2.666v-8Zm1.32-6.666C6.627.667.667 6.64.667 14s5.96 13.333 13.32 13.333c7.373 0 13.346-5.973 13.346-13.333S21.36.667 13.987.667Zm.013 24C8.107 24.666 3.333 19.892 3.333 14S8.107 3.333 14 3.333 24.667 8.107 24.667 14 19.893 24.666 14 24.666Z",
  fill: "currentColor"
})));

export default SvgAlertCircle;